import { entity, persistence } from "simpler-state"

import { AgeBasis, STAGE_PRESETS, StagePresetKey, resolve_days_old_basis } from "@/utils/deduction_age"

export interface IAgingPanelState {
  open: boolean
  basis: AgeBasis
  preset: StagePresetKey
  /** Explicit stage multi-select; null = follow the preset. */
  custom_stages: string[] | null
}

export const INITIAL_AGING_PANEL_STATE: IAgingPanelState = {
  open: false,
  // Default to the dispute-expiration view: "what's about to become unrecoverable" is the
  // actionable question, not "how old is the pile".
  basis: "until_dispute_expiration",
  preset: "all_open",
  custom_stages: null,
}

function deserializeFn(blob: string): IAgingPanelState {
  const data = JSON.parse(blob)
  return { ...INITIAL_AGING_PANEL_STATE, ...data }
}

export const AgingPanelState = entity(INITIAL_AGING_PANEL_STATE, [persistence("deduction_aging_panel", { deserializeFn })])

/** The stage scope currently in effect: the custom multi-select if set, else the preset's stages. */
export function effective_scope(state: IAgingPanelState): string[] | null {
  return state.custom_stages ?? STAGE_PRESETS[state.preset].stages
}

/** Live Days Old column basis — always the Aging panel's Age by selection. */
export function use_days_old_basis(): AgeBasis {
  return resolve_days_old_basis(AgingPanelState.use(s => s.basis))
}

/** Non-hook read for TanStack accessors (sort/filter) that can't subscribe. */
export function current_days_old_basis(): AgeBasis {
  return resolve_days_old_basis(AgingPanelState.get().basis)
}
